export let ClientOption: any = {
    headers: {
        'APIKEY': process.env.REACT_APP_API_CLIENT_KEY,
    }
};